import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { is } from '../../services';
import { TitleLevels, TitleMarkup } from './TitleEnum';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
const getTitleLevel = (level) => {
    if (level) {
        switch (level) {
            case TitleLevels.ONE:
                return is(`level-1`);
            case TitleLevels.TWO:
                return is(`level-2`);
            case TitleLevels.THREE:
                return is(`level-3`);
            default:
                return is(`level-${level}`);
        }
    }
};
/**
 * If no markup return div with default level 1
 * key in Enum works only in TS or with number enum for JS
 * for string enum (as in this case) we need to use Object.values.includes for JS usage
 * string enum aren't reverse mapped so the first solution doesn't work
 */
const isCorrectMarkup = (stringMarkup) => {
    return stringMarkup in TitleMarkup || Object.values(TitleMarkup).includes(stringMarkup);
};
/**
 * Title component
 * @param children {ReactNode} Title child
 * @param level {TitleLevels | TitleLevel | number} Title size : 1-3
 * @param inverted {Boolean} Title white color
 * @param typo {TypographyColor | TypographyTransform | TypographyBold | TypographyAlign} Typos
 * @param onClick {Function} onClick Event
 * @param skeleton {Boolean} Title Skeleton
 * @param accessibilityLabel {string} Accessibility label
 * @param testId {string} Test Id for Test Integration
 * - --------------- WEB PROPERTIES ----------------------------------
 * @param markup {string} h1 | h2 | h3 | h4 | h5 | h6 | p | span | div
 * @param className {string} Additionnal css classes
 * @param subtitle {boolean} Subtitle below title
 * @param suptitle {boolean} Suptitle above title
 * - --------------- NATIVE PROPERTIES ----------------------------------
 * @param style {object} Additional styles
 */
const Title = ({ level = TitleLevels.ONE, markup, children, className, typo, skeleton, inverted, onClick, testId, accessibilityLabel, subtitle, suptitle, marginless, htmlContent, ...others }) => {
    const [isLoading, setIsLoading] = useState(skeleton || false);
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('title', level && getTitleLevel(level), typo, isLoading ? is('loading') : is('loaded'), inverted && is('inverted'), marginless && is('marginless'), className));
    const subtitleClasses = hashClass(styled, clsx('subtitle', className));
    const suptitleClasses = hashClass(styled, clsx('suptitle', className));
    useEffect(() => {
        setIsLoading(skeleton || false);
    }, [skeleton]);
    const Tag = markup && isCorrectMarkup(markup) ? markup : 'div';
    const getClassname = () => {
        if (subtitle)
            return subtitleClasses;
        if (suptitle)
            return suptitleClasses;
        return classes;
    };
    return (React.createElement(Tag, { "data-testid": testId, "aria-label": accessibilityLabel, onClick: onClick, className: getClassname(), ...(htmlContent && { dangerouslySetInnerHTML: { __html: htmlContent } }), ...others }, children));
};
export default Title;
//# sourceMappingURL=Title.js.map